<div class="project-tasks-tab h-full flex flex-col gap-3 pr-2 overflow-y-auto">

  <!-- Selected Client / Selected Project Header Card -->
  <app-project-header-card></app-project-header-card>

  <!-- Project Tasks Form Card -->
  <div class="project-task-form-section rounded-md p-4 flex flex-col gap-3">

    <div class="project-task-section-title font-semibold text-gray-600 mb-1">
      Project Tasks
    </div>

    <form [formGroup]="taskForm" class="flex flex-col gap-3">

      <!-- First Row -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-9 gap-y-4">
        <!-- Task Reference -->
        <div class="project-task-field">
          <input
            type="text"
            formControlName="taskRef"
            class="project-task-input"
            placeholder=" "
          />

          <span class="project-task-floating-label">
            Task Ref <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Description -->
        <div class="project-task-field">
          <input
            type="text"
            formControlName="projectTaskDescription"
            class="project-task-input"
            placeholder=" "
          />

          <span class="project-task-floating-label">
            Description <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Manager -->
        <div class="project-task-field project-task-select-field"
          [class.has-value]="taskForm.get('projectTaskManager')?.value">
        <ng-select [items]="employeesList" formControlName="projectTaskManager" placeholder=" "></ng-select>
        <span class="project-task-floating-label">Manager <span class="text-red-500">*</span></span>
      </div>

        <!-- Fixed Cost Value -->
        <div class="project-task-field">
          <input
            type="number"
            formControlName="fixedCostValue"
            class="project-task-input"
            placeholder=" "
            min="0"
          />

          <span class="project-task-floating-label">
            Fixed Cost Value <span class="text-red-500">*</span>
          </span>

          <div
            class="validation-error"
            *ngIf="taskForm.get('fixedCostValue')?.hasError('min')
                  && taskForm.get('fixedCostValue')?.touched"
          >
            Fixed Cost Value can't be negative.
          </div>
        </div>

      </div>

      <!-- Second Row -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-9 gap-y-4">

        <!-- Fixed Cost Start -->
        <div class="project-task-field project-task-date-field">
          <input matInput [matDatepicker]="startPicker" readonly (click)="startPicker.open()"
                formControlName="fixedCostStart" class="project-task-input" placeholder=" " />
          <span class="project-task-floating-label">Fixed Cost Start</span>
          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </div>

        <!-- Fixed Cost End -->
        <div class="project-task-field project-task-date-field">
          <input matInput [matDatepicker]="endPicker" readonly (click)="endPicker.open()"
                formControlName="fixedCostEnd" class="project-task-input" placeholder=" " />
          <span class="project-task-floating-label">Fixed Cost End</span>
          <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </div>

        <!-- Active -->
        <div class="project-task-checkbox">

          <input
            type="checkbox"
            id="taskActiveCheck"
            formControlName="active"
            class="h-4 w-4"
          />

          <label
            for="taskActiveCheck"
            class="text-xs text-gray-700">
            Active <span class="text-red-500">*</span>
          </label>

        </div>

        <!-- Default -->
        <div class="project-task-checkbox">

          <input
            type="checkbox"
            id="taskDefaultCheck"
            formControlName="isDefault"
            class="h-4 w-4"
          />

          <label
            for="taskDefaultCheck"
            class="text-xs text-gray-700">
            Is Default <span class="text-red-500">*</span>
          </label>

        </div>

      </div>

      <!-- Action Buttons -->
      <div class="flex flex-row gap-3 mt-2 items-center">

        <!-- Submit -->
        <button
          mat-raised-button
          type="button"
          [disabled]="taskForm.invalid"
          class="project-task-submit-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4"
          (click)="onSubmitTask()">

          <div class="flex items-center gap-2">
            <mat-icon>add</mat-icon>
            <span>Submit</span>
          </div>

        </button>

        <!-- Push Save/Delete/Clear/Next group to the right -->
        <div class="flex-grow"></div>

        <!-- Save -->
        <button
          mat-raised-button
          type="button"
          [disabled]="!isSaveEnabled"
          class="project-task-save-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4 disabled:opacity-50"
          (click)="onSaveTasks()">

          <div class="flex items-center gap-2">
            <mat-icon>save</mat-icon>
            <span>Save</span>
          </div>

        </button>

        <!-- Delete -->
        <button
          mat-raised-button
          type="button"
          [disabled]="!isDeleteEnabled"
          class="project-task-delete-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4 disabled:opacity-50"
          (click)="onDeleteTasks()">

          <div class="flex items-center gap-2">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </div>

        </button>

        <!-- Next -->
        <button
          mat-raised-button
          type="button"
          class="project-task-submit-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4"
          (click)="onNextTab()">

          <div class="flex items-center gap-2">
            <mat-icon>skip_next</mat-icon>
            <span>Next</span>
          </div>

        </button>

      </div>

    </form>
  </div>

  <!-- AG Grid Table -->
  <div
    class="w-full flex-1 project-task-grid"
    style="min-height: 220px;">

    <ag-grid-angular
      class="ag-theme-balham w-full h-full"
      style="min-height: 220px; padding-right: 12px"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions"
      [components]="components"
      [suppressRowClickSelection]="true"
      (cellValueChanged)="onCellValueChanged($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (cellEditingStarted)="onCellEditingStarted($event)"
      (cellEditingStopped)="onCellEditingStopped($event)">
    </ag-grid-angular>

  </div>

</div>